import React from "react";
import { Box } from "@material-ui/core";
import { css } from "@emotion/css";

const LessonPreviewMobile: React.FC = ({ children }) => (
  <Box className={styles.frame}>
    <Box className={styles.notch} />
    <Box className={styles.screen}>{children}</Box>
  </Box>
);

export default LessonPreviewMobile;

const styles = {
  frame: css`
    width: 320px;
    height: 640px;
    border: 12px solid #222;
    border-radius: 36px;
    background: #fff;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  `,
  notch: css`
    width: 80px;
    height: 16px;
    background: #222;
    border-radius: 0 0 12px 12px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  `,
  screen: css`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: #fafafa;
  `,
};
